<title>{{ homePage.htmlTitle }}</title>
<app-user-card [banner]="homePage.banner" [noteSections]="homePage.noteSectionsForAnnouncements" [userCards]="homePage.userCards"></app-user-card>
<div class="container mt-3 pb-3">
  <div class="row">
    <div class="container pt-3">
      <app-section class="" [sections]="homePage.sectionsJustBelowBanner"></app-section>
    </div>
    <div class="col-md-12 col-sm-12 col-lg-9">
      <div>
        <h3>{{ NDCCreditVouchers }}</h3>
      </div>
      <app-credit-voucher-card [creditVoucherCards]="homePage.creditVoucherCards"></app-credit-voucher-card>
      <br />
      <div>
        <h3>{{ LatestAPIProductUpdates }}</h3>
      </div>
      <app-table-section [isHomePage]="true" [apiProductUpdatesTitle]="revisionNoticeTitle" [apiProductUpdates]="homePage.revisionNotices"></app-table-section>
      <div *ngIf="RevisionNoticeButton || RevisionNoticeUrl" class="row">
        <div class="col-sm-12 push-right">
          <a [href]="RevisionNoticeUrl" role="button"> {{ RevisionNoticeButton }} </a>
        </div>
      </div>

      <app-section [sections]="homePage.sectionsJustBelowTable"></app-section>

      <h4 class="mt-5">{{ UsefulLinks }}</h4>

      <app-useful-link-card [usefulLinkCards]="homePage.usefulLinkCards"></app-useful-link-card>
    </div>
    <div *ngIf="homePage.newsSectionCards.length > 0" class="col-md-12 col-sm-12 col-lg-3 pt-20 pb-30 news-card">
      <app-news-section-card [title]="NewsCardTitle" [newsUrl]="NewsUrl" [seeAllNews]="SeeAllNews" [headImage]="NewsCardImage" [newsSectionCards]="homePage.newsSectionCards"></app-news-section-card>
    </div>
  </div>
</div>
